import { ComponentIds, GuestConnectionsComponent, HierarchyUtils } from '@inter-ikea-core/core';
import { CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY, ProductType } from '@inter-ikea-storageone/range';
import { BehaviorParameters } from 'rangeConfig/@types';
import { addInteriorSuggestionEntityToFrame } from 'rangeConfig/shared/utils/interiorSuggestions';

/**
 * Adds a Jonaxel interior suggestion to the selected entity.
 *
 * @param {BehaviorParameters} params - The parameters for the behavior.
 * @param {Object} params.coreApi - The core API object.
 * @param {Object} params.props - The properties object.
 * @param {string} [params.props.coreProductId] - The core product ID.
 * @param {string[]} [params.props.coreProductIds] - The list of core product IDs.
 */
const addJonaxelInteriorSuggestion = ({ coreApi, props }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return;

  const coreProductId = props.coreProductId || props.coreProductIds[0];
  const interiorSuggestionEntity = coreApi.getServices().productManager.createEntity(coreProductId);
  if (!interiorSuggestionEntity) return;

  // Find cloth rails on the outside of the frame. We do not want to delete them when adding the interior suggestion.
  const clothRailsOnOutsideOfFrame = HierarchyUtils.children(selectedEntity).filter(
    child =>
      coreApi.entities.isProductType(child, ProductType.JONAXEL_CLOTH_RAIL_ADJUSTABLE) &&
      child
        .getComponent<GuestConnectionsComponent>(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID)
        ?.connections.some(c => c.hostConnector.key.includes(CLOTH_RAIL_OUTSIDE_CONNECTOR_KEY))
  );

  addInteriorSuggestionEntityToFrame(
    interiorSuggestionEntity,
    selectedEntity,
    coreApi,
    clothRailsOnOutsideOfFrame
  );
};

export default addJonaxelInteriorSuggestion;
